module.exports = __webpack_public_path__ + "static/media/camera-thin.525e5a1f.svg";